import axios from "axios";
import { attachAuth } from "services/authAxios";

// ─────────────────────────────────────────────────────────────────────────────
// Cliente del object store S3 (en .151), DESACOPLADO de calidad-ia (.153).
//
// Pega DIRECTO a s3-api.beartrackapp.com con el MISMO Bearer JWT de beartrack
// (la .151 valida el JWT server-side; el front nunca envía credenciales de
// servicio). Rutas bajo /panel/*.
//
// Notas del contrato (.151):
//   - Mientras el secret JWT no esté seteado en .151, /panel/* da 503 (esperado).
//   - El default hornea la URL pública (CRA hornea la env en build).
// ─────────────────────────────────────────────────────────────────────────────

const BASE_URL = process.env.REACT_APP_S3_API || "https://s3-api.beartrackapp.com";

const S3Axios = axios.create({
  baseURL: BASE_URL,
  timeout: 300000, // subidas pueden ser grandes (hasta max_upload_size)
  headers: {
    "Content-Type": "application/json",
  },
});

attachAuth(S3Axios);

const enc = (s) => encodeURIComponent(s);
const encPath = (p) => String(p).split("/").map(encodeURIComponent).join("/");

// Los buckets public_read se sirven DIRECTO por su URL pública (no por /panel).
export const s3PublicUrl = (bucket, key) => `${BASE_URL}/${bucket}/${encPath(key)}`;

export const s3AdminService = {
  // ── Lectura ──
  getServerInfo: () => S3Axios.get("panel/server-info").then((r) => r.data),
  getBuckets: () => S3Axios.get("panel/buckets").then((r) => r.data),
  getBucketStats: (bucket) => S3Axios.get(`panel/buckets/${enc(bucket)}/stats`).then((r) => r.data),
  // params = { prefix, marker, limit } — paginar mandando next_marker como marker.
  getBucketObjects: (bucket, params) =>
    S3Axios.get(`panel/buckets/${enc(bucket)}/objects`, { params }).then((r) => r.data),
  getKeys: () => S3Axios.get("panel/keys").then((r) => r.data),

  // ── Aditivas ──
  createBucket: (name) => S3Axios.post("panel/buckets", { name }).then((r) => r.data),
  // Sube el archivo como body CRUDO (raw bytes, NO multipart) con su Content-Type.
  uploadObject: (bucket, path, file, contentType) =>
    S3Axios.put(`panel/upload/${enc(bucket)}/${encPath(path)}`, file, {
      headers: { "Content-Type": contentType || file?.type || "application/octet-stream" },
    }).then((r) => r.data),
};

export default s3AdminService;
